module.exports = __webpack_public_path__ + "static/media/emailSentLogo.425fe58f.svg";